module.exports = __webpack_public_path__ + "static/media/18.a1f19f78.jpg";